export const CONTACTS = {
  phone: import.meta.env.VITE_CONTACTS_PHONE,
  email: import.meta.env.VITE_CONTACTS_EMAIL,
  supportBlocks: [
    {
      title: 'contacts.support',
      contacts: [
        {
          type: 'phone',
          label: '+7 7132 444 777',
          url: 'tel:77132444777'
        }
      ]
    },
    {
      title: 'contacts.online.support',
      footer: 'contacts.online.support.footer',
      contacts: [
        {
          type: 'phone',
          label: '+7 7132 444 777 (доб. 9905)',
          url: 'tel:77132444777,9905'
        }
      ]
    }
  ]
}

export const CART_FEATURES: { key: number, icon: string }[] = []
